import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { formatCount } from "../Home/useAnimatedCount";

const TokenBalance = ({ balance, updating }) => {
  const { t } = useTranslation("common");

  if (balance == null) return null;

  return (
    <div className="token-balance">
      <div className="tb-icon">🪙</div>
      <div>
        <div className="tb-label">{t("Available Tokens")}</div>
        <div className="tb-val">{formatCount(balance)}</div>
        {updating ? (
          <div className="tb-updating">{t("Updating...")}</div>
        ) : null}
      </div>
    </div>
  );
};

TokenBalance.propTypes = {
  balance: PropTypes.number,
  updating: PropTypes.bool
};

TokenBalance.defaultProps = {
  balance: null,
  updating: false
};

export default TokenBalance;
